import React, { Component } from 'react';
import './styles/RMSSelectDrug.css';
import './styles/RMSDosage.css';
import backIcon from './images/backIcon.png';

class RMSDosage extends Component{

    constructor(props){
        super(props);

        this.state = {
            displayOffLabelWarning: false
        }
    }

    componentDidMount(){
        let input = document.getElementById('dosageInput');
        if(input){
            input.focus();
        }
    }

    checkValue = (e) =>{
        if(e.target.value < 0 || e.target.value > 1000){
            this.setState({displayOffLabelWarning: true});
        }else{
            this.setState({displayOffLabelWarning: false});
        }
    }

    dosageSelected = (item) =>{
        this.props.setSelectedDosage(item);
        this.props.changePage('RMSResults');
    }

   render(){
        let dosageLabel = '';
        let resultsButton = '';

        if(this.state.displayOffLabelWarning){
            dosageLabel = (<div className="row">
                <div className="col-lg-12 dosage-label-warning">
                    <span>WARNING: DOSAGE AMOUNT IS OFF LABEL!</span>
                </div>
            </div>)

            resultsButton = (
                <div className="row results-button results-button-warning">
                    <div className="col-lg-12">
                        <span>Results</span>
                    </div>
                </div>
            )

        }else{
            dosageLabel = (<div className="row">
                <div className="col-lg-12 dosage-label">
                    <span>Enter amount in ml</span>
                </div>
            </div>)

            let input = document.getElementById('dosageInput');

            if(input && input.value.length > 0){
                resultsButton = (
                    <div className="row results-button" onClick={() => this.dosageSelected(input.value)}>
                        <div className="col-lg-12">
                            <span>Results</span>
                        </div>
                    </div>
                )
            }else {
                resultsButton = '';
            }
        }

        return(
            <div className="row">
                <div className="col-lg-4 col-xs-12 drug-wrapper">
                    <div className="row">
                        <div className="col-lg-12 col-xs-12 drug-title">
                            <h4><img className="backbutton" src={backIcon} alt="Go Back" onClick={() => this.props.changePage('RMSSelectDrug')}/> Dosage</h4>
                        </div>
                    </div>
                    {dosageLabel}
                    <div className="row">
                        <div className="col-lg-12 dosage-drug-label">
                            <span>Drug: {this.props.selectedDrug.title}</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 dosage-input">
                            <input id="dosageInput" type="text" placeholder="ml" onKeyUp={(e) => this.checkValue(e)}/>
                        </div>
                    </div>
                    {resultsButton}
                </div>

            </div>
        );
    }
}

export default RMSDosage;


// WEBPACK FOOTER //
// ./src/RMSDosage.js